/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useFeatureFlag } from '@/features/globalConfig';
import { getProductReviewsURL } from '@/features/product';
import { useProductDetails } from '@/features/product/api/getProductDetails';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export function useReviewsRedirect() {
  const router = useRouter();
  const productReviewsEnabled = useFeatureFlag('PRP_ENABLED') === 'true';
  const { data: productDetails, isSuccess: productDetailsSuccess } = useProductDetails();

  useEffect(() => {
    if (!productDetailsSuccess) {
      return;
    }
    if (productDetails.redirectURL) {
      const targetURL =
        productDetails.redirectPageType === 'ProductDetails'
          ? getProductReviewsURL(productDetails.redirectURL)
          : productDetails.redirectURL;

      void router.replace(targetURL);
    } else if (!productReviewsEnabled || !productDetails.product?.hasReviews) {
      void router.replace('/NotFound');
    }
  }, [
    productDetails?.redirectURL,
    productDetails?.product?.hasReviews,
    productDetails?.redirectPageType,
    productReviewsEnabled,
    router,
    productDetailsSuccess,
  ]);
}
